import { types } from 'mobx-state-tree';


const AREA_UNITS = {
    ACRES: 'acres',
    HECTARES: 'hectares',
    SQUARE_METERS: 'sq-m',
};

const AreaUnitEnum = types.enumeration('AreaUnit', Object.values(AREA_UNITS));

export {
    AreaUnitEnum,
};
export default AREA_UNITS;
